export default {
  data() {
    return {
      wRooms: [
        {
          id: null,
          name: null,
        },
      ],
      wRoomsWithKey: {
        null: {
          id: null,
          name: null,
        },
      },
    };
  },
  methods: {
    getWRooms() {
      this.$restClient.waitingRooms
        .all()
        .then((response) => {
          let wRoomsWithKey = {
            id: {
              id: null,
              name: null,
            },
          };
          response.data.forEach(function(wr) {
            wRoomsWithKey[wr.id] = {
              id: wr.id,
              name: wr.name,
            };
          });

          this.wRoomsWithKey = wRoomsWithKey;
          this.wRooms.push(...response.data);
          this.$helper.sortByKey(this.wRooms, "name");
          this.wRoomsAndUsersLoaded = true;
          if (this.usersLoaded) this.wRoomsAndUsersLoaded = true;
        })
        .catch((err) => {
          console.log(err);
          this.$notify.notifyError({ title: this.$t("failed") });
        });
    },
  },
};
